import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import { locations } from '../../utils/constants';

const myIcon = Leaflet.icon({
  iconUrl: require('../../assets/marker.png'),
  iconSize: [50, 46],
  iconAnchor: [25, 46],
  popupAnchor: [0, -41],
});

export default function LocationsMap() {
  return (
    <div className=' grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 pt-8 '>
      {locations.map((location) => (
        <div
          key={location.name}
          className='bg-black p-6 rounded-lg shadow-md h-fit'
        >
          {/* Location Name */}
          <h3 className='text-xl font-bold text-white mb-2 slavic-font '>
            {location.isOnline ? 'Проучивање' : 'Лично преузимање'}
          </h3>
          <h2 className='text-2xl font-bold mb-1 slavic-font text-yellow-400'>
            {location.name}
          </h2>

          {/* Location Address */}
          <p className='text-white text-xl mb-2'>{location.city}</p>
          <p className='text-white mb-2 text-sm'>{location.address}</p>
          <p className='text-white mb-2 text-sm'>{location.phone}</p>
          <p className='text-white mb-2 text-sm'>
            Радно време:{' '}
            <span className='text-yellow-400'>{location.workTime}</span>
          </p>

          {/* Map */}
          <MapContainer
            center={location.latLong}
            zoom={13}
            style={{ height: '300px', width: '100%' }}
            scrollWheelZoom={false}
            className='rounded-lg overflow-hidden'
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            />
            <Marker position={location.latLong} icon={myIcon}>
              <Popup>
                {location.mapName}
                <br />
                {location.mapCity}
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      ))}
    </div>
  );
}
// import React from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import Leaflet from "leaflet";
// import { locations } from "../../utils/constants";

// const myIcon = Leaflet.icon({
//   iconUrl: require("../../assets/marker.png"),
//   iconSize: [50, 46],
//   iconAnchor: [25, 46],
//   popupAnchor: [0, -41],
// });

// export default function LocationsMap() {
//   const position = [45.42069970529507, 19.889336293252782];
//   const position2 = [44.801995392767395, 20.487549262016795];
//   return (
//     <MapContainer
//       center={position}
//       zoom={8}
//       style={{ height: "400px" }}
//       scrollWheelZoom={false}
//     >
//       <TileLayer
//         className="location-map"
//         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//       />
//       {locations.map((location) => (
//         <Marker
//           key={location.mapName}
//           position={location.latLong}
//           icon={myIcon}
//         >
//           <Popup>
//             {location.mapName}
//             <br />
//             {location.mapCity}
//           </Popup>
//         </Marker>
//       ))}
//     </MapContainer>
//   );
// }
